<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
          <material-card
            v-if="selectedItem"
            :title="$t('views.portalcontacts.delete_contact')"
            :color="$vuetify.theme.themes.light.error"
            icon="delete"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn color text @click="dialogs.delete = false">
                {{
                $t("globals.cancel")
                }}
              </v-btn>
              <v-btn color="error" text @click="tryDelete">
                {{
                $t("globals.delete")
                }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200">
          <material-card
            v-if="selectedItem"
            :title="$t(formTitle)"
            :icon="formIcon"
            :color="formColor"
          >
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-container fluid>
                  <v-row>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Language"
                        :label="$t('globals.language')"
                        :rules="[$rules.required]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        type="number"
                        v-model="selectedItem.Order"
                        :label="$t('globals.priority')"
                        :rules="[$rules.requiredInteger]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Name"
                        :label="$t('globals.name')"
                        :rules="[$rules.required]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Email"
                        :label="$t('headers.contacts.email')"
                        :rules="[$rules.email, $rules.required]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Phone"
                        :label="$t('globals.phone')"
                        :rules="[$rules.required]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Address"
                        :label="$t('globals.address')"
                        :rules="[$rules.required]"
                        class="required"
                      ></no-autocomplete-textfield>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn :disabled="saving" text @click="dialogs.edit = false">
                {{
                $t("globals.cancel")
                }}
              </v-btn>
              <v-btn
                :loading="saving"
                :disabled="!valid"
                color="primary"
                @click="save()"
              >{{ $t("globals.save") }}</v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card
      :title="$t('views.portalcontacts.table_title')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="email"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :floatActions="floatActions"
        :rowActions="rowActions"
        fileNamePrefix="portal_contactss"
        :sortBy="'Name'"
        :sortDescending="true"
        identifier="portal_contactss"
        @error="error=$event"
      ></pbas-data-table>

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{$t(message)}}
        <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import PortalContactsHeaders from "../headers/PortalContacts";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield
  },
  mixins: [planSetter, portalPermission],
  directives: { mask },
  data() {
    return {
      rules:{
        phone:(v)=> {
            let val = this.unmask(v, this.telephoneMask);
            return (
              !val || this.$rules.phone(val)
            );
          }
      },
      telephoneMask: "(###) ### - ####",
      valid: true,
      selectedItem: null,
      error: null,
      dialogs: {
        edit: false,
        activate: false,
        deactivate: false
      },
      saving: false,
      provider: undefined,
      isNew: false,
      floatActions: [
        {
          name: "add",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.isNew = true;
            this.selectedItem = {
              PlanId: this.selectedPlan.Id,
            };
            this.dialogs.edit = true;
          }
        }
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: async item => {
            // try {
            //   this.selectedItem = await this.lock(
            //     this.getNotificationById,
            //     {
            //       plan: this.selectedPlan.Id,
            //       id: item.Id,
            //       dialogs: this.dialogs,
            //       dialog: "edit"
            //     },
            //     () => {
            //       this.dialogs.edit = false;
            //     }
            //   );
            //   this.isNew = false;
            //   this.dialogs.edit = true;
            // } catch (error) {
            //   this.error = error;
            // }
            this.isNew = false;
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.edit = true;
          }
        },
        // {
        //   name: "deactivate",
        //   icon: "toggle_off",
        //   title: "globals.deactivate",
        //   handler: async item => {
        //     // try {
        //     //   this.selectedItem = await this.lock(
        //     //     this.getNotificationById,
        //     //     {
        //     //       plan: this.selectedPlan.Id,
        //     //       id: item.Id,
        //     //       dialogs: this.dialogs,
        //     //       dialog: "deactivate"
        //     //     },
        //     //     () => {
        //     //       this.dialogs.deactivate = false;
        //     //     }
        //     //   );
        //     //   this.dialogs.deactivate = true;
        //     // } catch (error) {
        //     //   this.error = error;
        //     // }
        //     this.selectedItem = JSON.parse(JSON.stringify(item));
        //     this.dialogs.deactivate = true;
        //   },
        //   visible: item => item.Active
        // },
        // {
        //   name: "activate",
        //   icon: "toggle_on",
        //   title: "globals.activate",
        //   handler: async item => {
        //     // try {
        //     //   this.selectedItem = await this.lock(
        //     //     this.getNotificationById,
        //     //     {
        //     //       plan: this.selectedPlan.Id,
        //     //       id: item.Id,
        //     //       dialogs: this.dialogs,
        //     //       dialog: "activate"
        //     //     },
        //     //     () => {
        //     //       this.dialogs.activate = false;
        //     //     }
        //     //   );
        //     //   this.dialogs.activate = true;
        //     // } catch (error) {
        //     //   this.error = error;
        //     // }
        //     this.selectedItem = JSON.parse(JSON.stringify(item));
        //     this.dialogs.activate = true;
        //   },
        //   visible: item => !item.Active
        // },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: async item => {
            // try {
            //   this.selectedItem = await this.lock(
            //     this.getNotificationById,
            //     {
            //       id: item.Id,
            //       plan: this.selectedPlan.Id,
            //       dialogs: this.dialogs,
            //       dialog: "delete"
            //     },
            //     () => {
            //       this.dialogs.delete = false;
            //     }
            //   );
            //   this.dialogs.delete = true;
            // } catch (error) {
            //   this.error = error;
            // }
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          }
        }
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: PortalContactsHeaders
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    formTitle() {
      return this.isNew
        ? "views.portalcontacts.new_item"
        : "views.portalcontacts.edit_item";
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", ["saveContact", "deleteContact"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    async loadPlanData() {
      let url = "cms/odata/Plans(" + this.selectedPlan.Id + ")/Contacts";
      this.provider = new PbasOData(
        this.$axiosHttp,
        url,
        this.headers
      );
    },
    async save() {
      let item = JSON.parse(JSON.stringify(this.selectedItem));

      this.saving = true;
      try {
        await this.saveContact({
          plan: this.selectedPlan.Id,
          contact: item
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.edit = false;
        this.$refs.table.getDataAsync();

        if (this.$refs.form) this.$refs.form.resetValidation();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async activate(active) {
      this.selectedItem.Active = active;
      this.save();
      this.dialogs.deactivate = false;
      this.dialogs.activate = false;
    },
    async tryDelete() {
      this.saving = true;
      try {
        await this.deleteContact({
          plan: this.selectedPlan.Id,
          id: this.selectedItem.Id
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.delete = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }

      this.saving = false;
    }
  }
};
</script>


